import { imports } from "@/helpers/eventHelper";

export default {
  name: "EventPreview",
  props: [
    "event",
    "showDialog",
    "getStartEndDate",
    "getOrganizer",
    "getLocation",
    "categories",
    "features"
  ],
  methods: {
    getFeaturesForEvent(event) {
      if (event?.features?.length) {
        return this.features
          ?.filter(f => event.features?.includes(f._id))
          ?.map(f => f.short_title || f.title);
      } else return false;
    },
    getCategoriesForEvent(event) {
      if (event?.categories?.length) {
        return this.categories
          ?.filter(f => event.categories?.includes(f._id))
          ?.map(f => f.short_title || f.title);
      } else return false;
    },
    capitalizeFirstLetter(str) {
      return str[0].toUpperCase() + str.slice(1);
    },
    transformSnakeCase(str) {
      const arr = str.split("_");
      return arr.map(this.capitalizeFirstLetter).join(" ");
    }
  },
  computed: {
    cShowDialog: {
      get() {
        return this.showDialog;
      },
      set(value) {
        if (!value) this.$emit("closePreview");
      }
    },
    allContents() {
      const generalContents = [
        "Allgemein",
        {
          description: this.event.description,
          short_description: this.event.short_description
        }
      ];
      return [generalContents, ...this.alternativeContent].filter(
        ([, contents]) =>
          contents.description?.length || contents.short_description?.length
      );
    },
    alternativeContent() {
      if (!this.event.alternative_content) {
        return [];
      }
      return Object.entries(this.event.alternative_content);
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    activeImports() {
      return imports
        .filter(_ => _.isActive(this.currentPrincipal))
        .map(_ => _.typeId);
    }
  }
};
